/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderValidateCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderValidateCtrl', ["dialog", "$filter", "ngToast", "$q", "$scope", "$state", "$stateParams", "StockBrands", "StockItems", "StockPurchaseOrders", "StockSuppliers", "StockUnits", function(dialog, $filter, ngToast, $q, $scope, $state, $stateParams,
  StockBrands, StockItems, StockPurchaseOrders, StockSuppliers, StockUnits) {
  /**
  * Initial Setup
  */
  $scope.order = StockPurchaseOrders.get($stateParams.id);
  $scope.items = StockItems.getAllActive();
  $scope.units = StockUnits.getAllActive();
  $scope.brands = StockBrands.getAllActive();

  $scope.hideButtons = true;

  var preEditOrder = null;

  $scope.loading = $q.all([
    $scope.order.$promise,
    $scope.items.$promise,
    $scope.units.$promise,
    $scope.brands.$promise
  ]);

  $scope.loading.then(function() {
    $scope.loading = StockSuppliers.get($scope.order.supplierId).$promise;
    $scope.loading.then(function(supplier) {
      $scope.supplier = supplier;
      $scope.hideButtons = false;
    });
  });

  $scope.startedit = function() {
    $scope.editMode = true;

    preEditOrder = angular.copy($scope.order);
  };

  $scope.validateCancel = function() {
    if ($scope.editMode) {
      $scope.order = preEditOrder;
      $scope.editMode = false;
    } else {
      $state.go('^');
    }
  };

  $scope.updateOrder = function() {
    if ($scope.validateOrderForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors in this order.');
      return;
    }

    StockPurchaseOrders.update($scope.order)
    .then(function() {
      $scope.editMode = false;
    });
  };

  $scope.itemOptions = function() {
    var existingItems = {};
    angular.forEach($scope.order.lines, function(line) {
      existingItems[line.stockItemId] = true;
    });

    var avaliableItems = [];
    angular.forEach($scope.items, function(item) {
      if (!existingItems[item.id]) {
        avaliableItems.push(item);
      }
    });
    return avaliableItems;
  };

  /**
  * Add a new line to the order
  */
  $scope.addItem = function(value) {
    $scope.order.lines.push({
      stockCode: '',
      quantity: 1 * value.orderingUnitRatio,
      quantityOrdered: 0,
      unitCostOrdered: 0,
      unitCost: (value.currentPrice) ? value.currentPrice : 0,
      brandId: value.defaultBrandId,
      brandName: value.defaultBrandName,
      stockItemId: value.id,
      stockItemName: value.name,
      unitName: value.orderingUnitName,
      unitId: value.orderingUnitId,
      unitRatio: value.orderingUnitRatio,
      masterSupplierItemName: null,
      masterSupplierItemPackSize: 0,
      masterSupplierItemMinOrder: 0,
      quantityValid: true,
      stockCodeValid: false
    });

    $scope.order.stockCodeValid = false;
  };

  $scope.print = function() {
    $scope.pdfLoading = StockPurchaseOrders.print($scope.order.id);
  };

  $scope.quantityUpdated = function(line) {
    if (line.masterSupplierItemMinOrder !== 0 && line.masterSupplierItemPackSize !== 0) {
      var lineQuantity = line.quantity / line.unitRatio;

      if (line.masterSupplierItemMinOrder > 1) {
        lineQuantity = line.quantity;
      }

      line.quantityValid = lineQuantity >= line.masterSupplierItemMinOrder;
    }

    $scope.order.quantityValid = $filter('filter')($scope.order.lines, {quantityValid: false}).length === 0;
  };

  $scope.unitUpdated = function(line, newUnit) {
    line.quantity = (line.quantity / line.unitRatio) * newUnit.ratio;
    line.unitCost = (line.unitCost * line.unitRatio) / newUnit.ratio;
    line.unitRatio = newUnit.ratio;

    if ($scope.order.supplierValidateStockCode) {
      $scope.quantityUpdated(line);
    }
  };

  $scope.searchStockCodes = function(searchStr, line) {
    line.stockCode = searchStr;

    return StockItems.searchStockcodes(searchStr, $scope.order.supplierId).$promise;
  };

  $scope.stockcodeSelected = function(line, item) {
    line.stockCodeValid = true;
    line.masterSupplierItemName = item.name;
    line.masterSupplierItemPackSize = item.packSize;
    line.masterSupplierItemMinOrder = item.minOrder;

    $scope.order.stockCodeValid = $filter('filter')($scope.order.lines, {stockCodeValid: false}).length === 0;
  };

  $scope.stockcodeUpdated = function(line, index) {
    if ($scope.validateOrderForm['stockcode' + index].$invalid) {
      return;
    }

    StockItems.searchStockcodes(line.stockCode, $scope.order.supplierId)
    .$promise.then(function(supplierItems) {
      var isValid = false;
      angular.forEach(supplierItems, function(supplierItem) {
        if (supplierItem.itemCode == line.stockCode) {
          isValid = true;
          line.stockCodeValid = true;
          line.masterSupplierItemName = supplierItem.name;
          line.masterSupplierItemPackSize = supplierItem.packSize;
          line.masterSupplierItemMinOrder = supplierItem.minOrder;
        }
      });

      if (isValid === false) {
        line.stockCodeValid = false;
        line.masterSupplierItemName = null;
        line.masterSupplierItemPackSize = 0;
        line.masterSupplierItemMinOrder = 0;
      }

      //Since the minOrder may have changed, re-validate the quantity.
      $scope.quantityUpdated(line);

      $scope.order.stockCodeValid = $filter('filter')($scope.order.lines, {stockCodeValid: false}).length === 0;
    });
  };

  $scope.stockcodeLine = function(item) {
    return '<div style="display: inline-block; width: 85px">' + item.value.itemCode + '</div>' +
      '<div style="display: inline-block; width: 200px">' + item.value.name + '</div>' +
      '<div style="display: inline-block; width: 70px">' + (item.value.unit || 'Not Set') + '</div>' +
      '<div style="display: inline-block; width: 70px">' + (item.value.brand || 'Not Set') + '</div>';
  };

  $scope.stockcodeHeader = function() {
    return '<li class="ui-autocomplete-category"><div style="display: inline-block; width: 85px">Code</div>' +
      '<div style="display: inline-block; width: 200px">Description</div>' +
      '<div style="display: inline-block; width: 70px">Unit</div>' +
      '<div style="display: inline-block; width: 70px">Brand</div></li>';
  };

  $scope.supplierUnit = function(line) {
    if (line.masterSupplierItemName === null || line.masterSupplierItemMinOrder === 0) {
      return line.unitName;
    } else if (line.masterSupplierItemMinOrder == 1) {
      return 'Each';
    } else {
      return line.masterSupplierItemPackSize + ' Pack';
    }
  };

  $scope.supplierQuantity = function(line) {
    if (line.masterSupplierItemName === null || line.masterSupplierItemMinOrder <= 1) {
      return line.quantity / line.unitRaio;
    } else {
      return line.quantity / line.masterSupplierItemPackSize;
    }
  };

  $scope.minOrderQuantity = function(line) {
    if (line.masterSupplierItemMinOrder === 0) {
      return 0;
    } else if (line.masterSupplierItemMinOrder == 1) {
      return line.masterSupplierItemMinOrder;
    } else {
      return line.masterSupplierItemMinOrder / line.masterSupplierItemPackSize;
    }
  };

  $scope.orderDirect = function() {
    $state.go('^.SendDirect', {id: $scope.order.id}, {location: 'replace'});
  };

  $scope.email = function() {
    $state.go('^.SendEmail', {id: $scope.order.id}, {location: 'replace'});
  };

  $scope.fax = function() {
    $state.go('^.SendFax', {id: $scope.order.id}, {location: 'replace'});
  };
}]);
